import {COUNTRY_CODES} from '@/utils/constants/countryConstants'
import {ThemeProvider as NewThemeProvider} from '@pepsico-ds/ui/Utilities'
import {ThemeProvider as LegacyThemeProvider} from 'pepsico-ds'

const DEFAULT_THEME = 'Dark Peacock'

export const MarketThemeProvider = ({market, children}) => {
  console.log('MarketThemeProvider: market=', market)

  const ThemeProviderComponent = market === COUNTRY_CODES.US ? NewThemeProvider : LegacyThemeProvider

  return <ThemeProviderComponent defaultStyle={DEFAULT_THEME}>{children}</ThemeProviderComponent>
}

export default MarketThemeProvider
